import { gql } from "@apollo/client";

export const GENERATE_OTP = gql`
  mutation generate_otp_v3(
    $mobile_number: String!
    $get_standard: Boolean
    $request_type: String!
    $delivery_channel: String
    $device_intelligence: JSON
  ) {
    response: generate_otp_v3(
      mobile_number: $mobile_number
      get_standard: $get_standard
      request_type: $request_type
      delivery_channel: $delivery_channel
      device_intelligence: $device_intelligence
    ) {
      uuid
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation verify_otp_v3(
    $otp: String!
    $mobile_number: String!
    $request_type: String!
    $device_id: String
    $device_intelligence: JSON
  ) {
    response: verify_otp_v3(
      otp: $otp
      mobile_number: $mobile_number
      request_type: $request_type
      device_id: $device_id
      device_intelligence: $device_intelligence
    ) {
      id
      name
      access_token
      id_token
      supersari_partner
      supersari_config
      refresh_token
      fmcg_cookie
      fmcg_token
      fmcg_account_id
      state
      message
    }
  }
`;
